"use client";

/**
 * Shared form primitives for trader-tool calculators.
 *
 * The three calculator clients (risk-per-trade, max-drawdown, challenge-pass-odds)
 * each used to redefine these inline. Extracted to keep them DRY and let new
 * tools reuse the styling without copy-pasting.
 */

import { cn } from "@/lib/utils";

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="block text-xs uppercase tracking-wide text-[var(--fg-muted)] mb-2">{label}</span>
      {children}
    </label>
  );
}

export function NumberInput({
  value,
  onChange,
  step,
  min,
  max,
}: {
  value: number;
  onChange: (v: number) => void;
  step?: number;
  min?: number;
  max?: number;
}) {
  return (
    <input
      type="number"
      inputMode="decimal"
      value={Number.isFinite(value) ? value : 0}
      step={step}
      min={min}
      max={max}
      onChange={(e) => {
        const n = parseFloat(e.target.value);
        if (Number.isFinite(n)) onChange(n);
        else if (e.target.value === "") onChange(0);
      }}
      className="w-full rounded-[var(--radius)] border border-[var(--border)] bg-[var(--bg)] px-3 py-2 text-base focus:border-[var(--brand)] focus:outline-none"
    />
  );
}

export function Out({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string;
  highlight?: boolean;
}) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-[var(--fg-muted)]">{label}</div>
      <div
        className={cn(
          "mt-1 font-medium tabular-nums",
          highlight && "text-[var(--brand)] text-lg",
        )}
      >
        {value}
      </div>
    </div>
  );
}
